if (!customElements.get('lintico-customer-service')) {
  class LinticoCustomerService extends HTMLElement {
    constructor() {
      super();
      this.closeTimer = null;
      this.isPinned = false;
      this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleFocusIn = this.handleFocusIn.bind(this);
      this.handleFocusOut = this.handleFocusOut.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('.lintico-customer-service__trigger');
      this.panel = this.querySelector('.lintico-customer-service__panel');
      if (!this.trigger || !this.panel) return;

      this.trigger.addEventListener('click', this.handleTriggerClick);
      this.addEventListener('mouseenter', this.handleMouseEnter);
      this.addEventListener('mouseleave', this.handleMouseLeave);
      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('focusout', this.handleFocusOut);
      document.addEventListener('pointerdown', this.handleDocumentPointerDown);
      document.addEventListener('keydown', this.handleKeyDown);
    }

    disconnectedCallback() {
      this.clearCloseTimer();
      this.trigger?.removeEventListener('click', this.handleTriggerClick);
      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('focusout', this.handleFocusOut);
      document.removeEventListener('pointerdown', this.handleDocumentPointerDown);
      document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleTriggerClick() {
      if (this.isPinned) {
        this.close();
      } else {
        this.isPinned = true;
        this.open();
      }
    }

    handleMouseEnter() {
      this.clearCloseTimer();
      this.open();
    }

    handleMouseLeave() {
      if (!this.isPinned) this.scheduleClose();
    }

    handleFocusIn() {
      this.clearCloseTimer();
      this.open();
    }

    handleFocusOut(event) {
      if (!this.contains(event.relatedTarget) && !this.isPinned) {
        this.scheduleClose();
      }
    }

    open() {
      this.clearCloseTimer();
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.closest('.section-header')?.classList.add('section-header--customer-service-open');
    }

    close({restoreFocus = false} = {}) {
      this.clearCloseTimer();
      this.isPinned = false;
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.closest('.section-header')?.classList.remove('section-header--customer-service-open');
      if (restoreFocus) this.trigger.focus();
    }

    scheduleClose() {
      this.clearCloseTimer();
      this.closeTimer = window.setTimeout(() => {
        if (!this.matches(':hover') && !this.contains(document.activeElement)) {
          this.close();
        }
      }, 140);
    }

    clearCloseTimer() {
      if (this.closeTimer === null) return;
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    handleDocumentPointerDown(event) {
      if (!this.contains(event.target)) this.close();
    }

    handleKeyDown(event) {
      if (event.key === 'Escape' && !this.panel.hidden) {
        event.preventDefault();
        this.close({restoreFocus: true});
      }
    }
  }

  customElements.define('lintico-customer-service', LinticoCustomerService);
}
